type Props = {
  requirements: string[];
};

export const SBCRequirements = ({ requirements }: Props) => (
  <ul className="flex list-disc flex-col gap-y-1 pl-4 text-foreground-muted marker:text-foreground-faint">
    {requirements
      .filter((req) => req.trim() !== "")
      .map((req) => (
        <li key={req} className="text-[13px] leading-[1.45]">
          {req}
        </li>
      ))}
  </ul>
);
